import PropTypes from "prop-types";
import { Box } from "@mui/material";
import logo from "../images/logo120.png";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  return <Box component="img" src={logo} sx={{ ...sx }} />;
}
